const ICON_GEOMETRY = ({ color = "#000", strokeWidth = 3, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    fill="none"
    {...props}
  >
    <path
      className="path_svg"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M40.729 9.287a2.642 2.642 0 0 1 0 3.744l-13.906 13.91-4.46.719.717-4.462 13.906-13.91a2.64 2.64 0 0 1 3.743 0zM35.4 10.873l3.743 3.745M37.956 23.811v12.058m-2.885 2.988H14.027m-2.885-2.885V14.953m2.937-2.91h11.379"
    />
    <path
      className="path_svg"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      d="M12.012 14.517c1.378-.486 2.105-1.988 1.624-3.355a2.63 2.63 0 0 0-3.364-1.595c-1.378.487-2.105 1.989-1.624 3.356a2.63 2.63 0 0 0 3.364 1.594zM12.012 41.331c1.378-.486 2.105-1.988 1.624-3.355a2.63 2.63 0 0 0-3.364-1.594c-1.378.486-2.105 1.988-1.624 3.355a2.63 2.63 0 0 0 3.364 1.594zM38.827 41.331c1.377-.486 2.104-1.988 1.624-3.355a2.63 2.63 0 0 0-3.365-1.594c-1.377.486-2.104 1.988-1.624 3.355a2.63 2.63 0 0 0 3.365 1.594z"
    />
  </svg>
);

export default ICON_GEOMETRY;
